__turbopack_context__.v({
  "content": "PromoBannerCard-module-scss-module__alAc3a__content",
  "icon": "PromoBannerCard-module-scss-module__alAc3a__icon",
  "link": "PromoBannerCard-module-scss-module__alAc3a__link",
  "root": "PromoBannerCard-module-scss-module__alAc3a__root",
  "title": "PromoBannerCard-module-scss-module__alAc3a__title",
});
